











import { Vue, Component, Prop, Emit } from "vue-property-decorator";
import { SelectOption } from "@/interfaces/vuetify/selectOption";
import { find } from "lodash";

const deviceInfoToSelectOption = (device: MediaDeviceInfo): SelectOption => ({
  text: device.label,
  value: device.deviceId
});

@Component({})
export default class DeviceList extends Vue {
  @Prop({ required: true }) devices!: MediaDeviceInfo[];
  @Prop({ required: true }) label!: string;
  @Prop({ required: true }) selected!: MediaDeviceInfo;
  @Prop({ type: Boolean, default: false }) disabled!: boolean;

  get selectedDeviceId() {
    return this.selected?.deviceId;
  }

  get deviceOptions() {
    return this.devices.map(deviceInfoToSelectOption);
  }

  @Emit()
  deviceSelected(deviceId: string) {
    return find(this.devices, { deviceId });
  }
}
